import ShModel from 'sh-www/models/sh-model';
import { attr } from '@ember-data/model';

export const CAMPAIGN_IDS = {
  SELECT_REFERRAL_CAMPAIGN: 1,
  SELLER_REFER_CLIENT_DEFAULT_CAMPAIGN: 2,
}

export const DEPARTMENTS = [
  { value: 1, key: 'Content Marketing & Strategy' },
  { value: 2, key: 'Communications' },
  { value: 3, key: 'Production Operations' },
  { value: 4, key: 'Brand Marketing' },
  { value: 5, key: 'Social Media Marketing' },
  { value: 6, key: 'Creative' },
  { value: 7, key: 'Podcasting' },
  { value: 8, key: 'Corporate Communications' },
  { value: 9, key: 'Commercial Production' },
  { value: 10, key: 'Editorial Production' },
  { value: 11, key: 'Digital Media' },
  { value: 12, key: 'News / Broadcasting' },
  { value: 13, key: 'Design' },
  { value: 100, key: 'Other' },
];

class CampaignModel extends ShModel {
  @attr('string') name;
  @attr('string') description;
  @attr('number') rank;
}

export default CampaignModel;
